import $ from 'jquery';
import 'slick-carousel';

export default class Carousel {
  constructor(el) {
    this.el = el;
    $(function() {
      $(el).slick({
        infinite: true,
        slidesToShow: 1,
        dots: false,
        adaptiveHeight: !el.hasAttribute('data-carousel-fixed'),
        draggable: false,
        pauseOnHover: true,
        autoplay: true,
        speed: $(el).hasClass('m-carousel--highlight__items') ? 500 : 500,
        autoplaySpeed: $(el).hasClass('m-carousel--highlight__items') ? 5500 : 3000,
        prevArrow:
          '<button type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              draggable: true,
            },
          },
        ],
      });

      $(el).parent().fadeIn();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Carousel.js